import styled from "@emotion/styled";
import { Share } from "react-feather";
import { StyledPropsWithTheme } from "../../utils/globalTypes";

const ShareLogo = styled(Share)<StyledPropsWithTheme>`
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const Styled = { ShareLogo };
